import styled from "@emotion/styled"
import Search from "components/nav-v2/panes/search/Search"
import Navigation from "components/nav-v2/panes/search-navigation/Navigation"
import { cssVars, useNav } from "components/nav-v2/Wrapper"
import { useConsole } from "contexts/Console"
import getMediaQuery, { breakpoint } from "css/breakpoints"
import * as focusTrap from "focus-trap"
import { useLayoutEffect, useRef, useState } from "react"

const Pane = styled.div`
  --dir: 1;

  [dir="rtl"] & {
    --dir: -1;
  }

  pointer-events: none;
  content-visibility: hidden;

  [data-panes="secondary"] & {
    content-visibility: visible;

    & > div.main.content {
      pointer-events: auto;
    }
  }

  position: absolute;
  z-index: 0;
  inset-block: 0;
  inset-inline-start: 0;
  inset-inline-end: unset;
  width: 100vw;

  transform: translate3d(0, calc((1 - var(${cssVars.main.panes.secondary.expanded})) * -100%), 0);

  /* ${getMediaQuery("m", { max: false })} {
    inset-inline-start: unset;
    inset-inline-end: 0;
    width: var(--pane-width);

    transform: translate3d(calc((1 - var(${cssVars.main.panes.secondary.expanded})) * 100% * var(--dir)), 0, 0);
  } */

  display: grid;
  grid-template-rows: min-content var(${cssVars.main.bar.height});

  & > div.main.content {
    grid-column: 1/2;
    grid-row: 1/2;
    background: rgb(var(--pure-white));
    overflow: auto;
    scrollbar-width: thin;
    padding-block: calc(var(${cssVars.main.bar.height}) * 0.5);
  }

  & > aside {
    grid-column: 1/2;
    grid-row: 2/3;
    background: rgb(var(--pure-white));
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Secondary = props => {
  const console = useConsole()
  const rmain = useRef(null)
  const nav = useNav()
  const [hasSearchValue, setHasSearchValue] = useState(false)

  // const tools = props.tools || []

  useLayoutEffect(function focusTrapMgmt() {
    const controller = new AbortController()
    const refMQL = global.matchMedia(`(min-width: ${breakpoint.m})`)
    let trapTimeout

    let trap = null

    const onconditionschange = e => {
      try {
        const bar = props.rmainbar.current
        // const close = props.rclose.current
        const pane = rmain.current
        if (trap) {
          trap.deactivate()
          trap = null
        }

        // const desktop = refMQL.matches
        let initialFocus
        let stack
        switch (e.type) {
          case "change": {
            initialFocus = /* desktop ? close.querySelector("button") : */ bar.querySelector(".burger")

            if (pane.contains(document.activeElement)) {
              initialFocus = document.activeElement
            }

            stack = /*desktop ? [pane, close] : */ [pane, bar]
            break
          }
          //case "init":
          default: {
            initialFocus = /*desktop ? close.querySelector("button") : */ bar.querySelector(".burger")

            if (pane.contains(document.activeElement)) {
              initialFocus = document.activeElement
            }

            stack = /*desktop ? [pane, close] : */ [pane, bar]
            break
          }
        }

        trap = focusTrap.createFocusTrap(stack, {
          allowOutsideClick: true,
          initialFocus,
          isolateSubtrees: "aria-hidden",
          returnFocusOnDeactivate: false,
        })

        clearTimeout(trapTimeout)
        trapTimeout = setTimeout(
          () => {
            trap.activate()
          },
          e.type !== "init" ? 300 : 4
        )
      } catch (error) {
        console.error(error)
      }
    }

    const onsecondaryexpandedchange = latest => {
      if (trap && latest === 0) {
        trap.deactivate()
        document.activeElement.blur()
        trap = null
        nav.__internals.dispatchEvent(new Event("focus:trap:deactivate:secondary"))
      } else if (!trap && latest > 0) {
        refMQL.addEventListener("change", onconditionschange, { signal: controller.signal })
        onconditionschange({ type: "init" })
      }
    }

    const off = nav.main.panes.secondary.motion.expanded.on("change", onsecondaryexpandedchange)
    onsecondaryexpandedchange(nav.main.panes.secondary.motion.expanded.get())
    return () => {
      clearTimeout(trapTimeout)
      controller.abort()
      off()
      if (trap) trap.deactivate()
    }
  })

  console.verbose("Nav:Panes:Secondary(%o)", props)
  return (
    <Pane ref={rmain} className='pane secondary main'>
      <div className='main content'>
        <Search onHasValueChange={setHasSearchValue} />
        {!hasSearchValue && <Navigation {...props} />}
      </div>
    </Pane>
  )
}

export default Secondary
